<div class="container">

  <div *ngIf="type=='attachment'">
    {{ filesCountText }}
  </div>

  <div class="files" [ngClass]="{ 'files-grid-2-col': showInGrid }">
    <div *ngFor="let fileData of downloadFilesControl; index as i">
      <div class="file-item" [ngClass]="{ 'file-item-margin': showInGrid}">
        <app-file-uploaded-item
          [filePathOldStructure]="filePathOldStructure"
          [fileData]="fileData"
          [allowDelete]="true"
          [imgURL]="imgURL[i]"
          (onDeleteEmitter)="onRemoveFileClick(fileData.name!, i)"
        >
        </app-file-uploaded-item>
      </div>
    </div>
  </div>

  <div *ngIf="showSelectFileDialog">
    <div class="add-file">
      <input #hiddenfileinput
        type="file" accept={{attribAccpet}} hidden multiple
        (change)="onFilesSelected($event)" 
      />
      <div (click)="hiddenfileinput.click()">
        <div *ngIf="type=='attachment'; else backgroundFile">
          <div class="attachment">
            <div class="image">
              <img src="../../../../assets/icons/BlueIconClips.svg">
            </div>
            <p>
              {{ addItemText }}
            </p>
          </div>
        </div>
        <ng-template #backgroundFile>
          <div class="background">
            <span class="label">+ Adicionar Capa</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

</div>
